import React, { Component } from "react";
import { PrimaryFormNav } from "../../components/PrimaryFormNav";
import { MinorOffenderSelectionCard } from "../../components/MinorOffenderSelectionCard";
class MinorVisitSelection extends Component {
  state = {
    heading: "Who Will the Minor Visit?",
    showProgressBar: true,
    badge: 75,
    pageId: "minor-visitation-select"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step,
      this.state.badge
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handlePrevious = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  handleSubmit = () => {
    const isErr = this.props.validateMinorRelationshipFields();
    const stepData = this.props.stepData;

    if (!isErr) {
      this.props.nextStep(stepData);
    } else {
      this.scrollToError();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    const minorSelectedOffenders = fields.minorSelectedOffenders;
    let errFields = [];
    Object.keys(minorSelectedOffenders).map(offenderId => {
      if (
        minorSelectedOffenders[offenderId].RelationshipToMinor.className ===
        "input-err"
      ) {
        errFields.push(offenderId);
      }
      return offenderId;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    firstErr.scrollIntoView();
  };
  render() {
    const fields = this.props.fields;
    const selectedOffenders = fields.selectedOffenders;
    const minorSelectedOffenders = fields.minorSelectedOffenders;
    return (
      <div className="col-14">
        <p className="h2-style">
          Minor Applying for Visitation:&nbsp;
          {this.props.fields.currentMinor.fields.firstName.value}&nbsp;
          {this.props.fields.currentMinor.fields.middleName.value}&nbsp;
          {this.props.fields.currentMinor.fields.lastName.value}
        </p>
        <p>
        Check the inmate(s) you would like the minor to visit, then select the 
        inmate's relationship to the minor.
        </p>
        <form id="minor-visit-select">
          <ul className="visitation-result-cards">
            {Object.keys(selectedOffenders).map(offenderId => {
              let checked;
              let selectClassName;
              let selectErrMessage;
              if (minorSelectedOffenders[offenderId]) {
                checked = true;
                selectClassName =
                  minorSelectedOffenders[offenderId].RelationshipToMinor
                    .className;
                selectErrMessage =
                  minorSelectedOffenders[offenderId].RelationshipToMinor
                    .errMessage;
              } else {
                checked = false;
              }
              return (
                <MinorOffenderSelectionCard
                  checkName={offenderId}
                  checkVal={checked}
                  selectVal={
                    checked
                      ? minorSelectedOffenders[offenderId][
                          "RelationshipToMinor"
                        ]["value"]
                      : ""
                  }
                  selectDisabled={!checked}
                  key={offenderId}
                  selectId={offenderId}
                  className="relation-to-minor"
                  selectClassName={selectClassName}
                  selectErrMessage={selectErrMessage}
                  fullName={selectedOffenders[offenderId].FullName}
                  age={selectedOffenders[offenderId].Age}
                  sex={selectedOffenders[offenderId].Gender}
                  race={selectedOffenders[offenderId].Race}
                  offenderId={selectedOffenders[offenderId].OffenderId}
                  locationName={selectedOffenders[offenderId].LocationName}
                  projectedReleaseDate={
                    selectedOffenders[offenderId].ProjectedReleaseDate
                  }
                  alias={selectedOffenders[offenderId].Alias}
                  handleAddOffender={this.props.handleAddOffender}
                  setMinorOffenderRelationship={
                    this.props.setMinorOffenderRelationship
                  }
                />
              );
            })}
          </ul>
        </form>
        <PrimaryFormNav
          prevLabel="Step 9"
          nextLabel="Next"
          handlePrevious={this.handlePrevious}
          handleNext={this.handleSubmit}
          options={Object.keys(fields)}
        />
      </div>
    );
  }
}

export default MinorVisitSelection;



// WEBPACK FOOTER //
// ./src/pages/MinorVisitSelection/MinorVisitSelection.js